export default "/img/CM.76c8a82f946b31c33b5d1f51b3c3a7eb.png";